export default __webpack_public_path__ + "static/media/podium-ico.27a04a76.svg";